import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../_services/Authentication.service';
import { BehaviorSubject } from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
        null
    );

    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // IMPORTANTE: Los interceptores sólo se llaman cuando se hacen peticiones HTTP al servidor.
        // Si una sección o página no necesita comunicación con el servidor, entonces no se pasa por aquí.
        // console.log('--> JwtInterceptor url:');
        // console.log(request.url);

        let internal_url = true;

        if (request.url === 'http://data.fixer.io/api/latest') {
        // if (request.url === 'http://mindicador.cl/api/dolar') {

            console.log('--> Interceptada petición conversión Dolar USD - Peso Chileno CLP:');
            console.log(request.url);

            internal_url = false;
        }

        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token && internal_url) {
            // console.log('--> Existe token para el usuario: Se añade a la cabecera.');
            // console.log(currentUser);

            const new_request = request.clone({
                // IMPORTANTE: Se añaden/modifican las cabeceras que la aplicación va a necesitar (el token y el entorno).
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`,
                    ActualEnviroment: currentUser.enviroment
                    // 'Access-Control-Allow-Origin': '*',
                    // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                    // 'Access-Control-Allow-Headers': 'ActualEnviroment, Content-Type, Authorization, ' +
                    // 'Access-Control-Allow-Origin, Access-Control-Allow-Methods'
                }
            });
            return next.handle(new_request);
        } else {
            // IMPORTANTE: Las direcciones usadas para hacer peticiones externas a terceros deben pasar por aquí sin
            // modificar sus cabeceras ya que sus políticas de seguridad "cors" seguramente bloquearán nuestras peticiones
            // al llevar cabeceras propias internas de Vidrioservice (en nuestro caso "Authorization" y "ActualEnviroment").
            console.log('--> NO existe token para el usuario. No se puede añadir a la cabecera:');
            console.log(currentUser);
            return next.handle(request);
        }
    }

/*
    intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).lift(evt => {

        console.log('--> !!!!Entrando en interceptor JWT!!!!!');

        const currentUser = this.authenticationService.currentUserValue;

        if (currentUser && currentUser.token) {
            console.log('--> Existe token para el usuario:');
            console.log(currentUser);
        }

        if (evt instanceof HttpResponse) {
            console.log('---> statusXXX:', evt.status);
            console.log('---> filterXXX:', req.params.get('filter'));
        } else {
            console.log('---> evtXXX:');
            console.log(evt);
        }
    });

  } */
}
